import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { useLocale, useService } from "../../../../hooks";
import { NavigatorContext } from "../../../../context";

export const useAddCampaign = () => {
  const { t } = useLocale();
  const { navigateTo } = useContext(NavigatorContext);
  const { fetchByAttr, save, update } = useService("Data", "campaign");
  const { setTitle } = useService("Meta");
  const { showAlert, generateUID } = useService("Misc");
  const { urlToSplitData, getLocationData } = useService("Router");
  const [content, setcontent] = useState<string>("");
  const [uid, setuid] = useState<string>("");
  const [mode, setmode] = useState<"add" | "edit" | "view">("add");
  const [name, setname] = useState<string>("");
  const [image, setimage] = useState<string>("[]");

  useEffect(() => {
    setTitle(t("addCampaign"), "admin");
  }, [setTitle, t]);

  const urlData = urlToSplitData(getLocationData().pathname);
  const urlMode = urlData[3];
  const urlUid = urlData[4];

  const getCampaignData = useCallback(
    async (query) => {
      const result = await fetchByAttr(query);
      if (result.status) {
        let campaignData = result.data[0];
        setname(campaignData.name);
        setmode("edit");
        setcontent(campaignData.content);
        setimage(campaignData.image);
        setuid(campaignData.uid);
      } else showAlert({ type: "error", msg: "No campaigns added yet!" });
    },
    [fetchByAttr, showAlert]
  );

  useEffect(() => {
    if (urlMode === "edit") {
      getCampaignData({ uid: urlUid });
    }
  }, [getCampaignData, urlMode, urlUid]);
  const addCampaign = useCallback(
    async (e) => {
      e.preventDefault();
      let error = false,
        errorMsg = "",
        campaignObject = {
          content,
          name,
          image,
          uid: mode === "add" ? generateUID() : uid,
        };
      if (content === "") {
        errorMsg = t("errorMsg.required.campaignContent");
        error = true;
      }
      if (name === "") {
        errorMsg = t("errorMsg.required.campaignName");
        error = true;
      }
      if (!error) {
        if (mode === "add") {
          const result = await save(campaignObject);
          if (result.status) {
            showAlert({ type: "success", msg: t("success.addCampaign") });
            navigateTo({ route: "/admin/campaign/list" });
          } else {
            showAlert({ type: "error", msg: t("errorMsg.fail.addCampaign") });
          }
        } else {
          let data = {
            query: JSON.stringify({ uid }),
            campaignData: JSON.stringify(campaignObject),
          };
          const result = await update(data);
          if (result.status) {
            showAlert({ type: "success", msg: t("success.updateCampaign") });
            navigateTo({ route: "/admin/campaign/list" });
          } else {
            showAlert({
              type: "error",
              msg: t("errorMsg.fail.updateCampaign"),
            });
          }
        }
      } else showAlert({ type: "error", msg: errorMsg });
    },
    [
      content,
      generateUID,
      image,
      mode,
      name,
      navigateTo,
      save,
      showAlert,
      t,
      uid,
      update,
    ]
  );

  const setCampaignName = (e) => setname(e.target.value);

  const setCampaignContent = (e) => setcontent(e.target.value);
  return {
    mode,
    name,
    setCampaignName,
    content,
    setCampaignContent,
    addCampaign,
  };
};
